<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Выдача БСО') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg create bgw-pdg-20">
        <v-form
          ref="form"
          lazy-validation
          @submit.prevent="updateInvoiceBso"
        >
          <!--Накладная-->
          <div class="form-group">
            <div class="quota-fields justify-center">
              <div class="quota-field" :class="{ invalid: $v.invoiceBso.number.$error }">
                <label>
                  <strong>
                    {{ $t('Накладная') }} №
                  </strong>
                </label>
                <v-text-field
                  v-model="invoiceBso.number"
                  outlined
                  dense
                  required
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field field-md" :class="{ invalid: $v.invoiceBso.oopt.$error }">
                <label>{{ $t('Получатель') }}:</label>
                <v-select
                  item-value="id"
                  item-text="transName"
                  :items="oopts"
                  v-model="invoiceBso.oopt"
                  outlined
                  dense
                  required
                  clearable
                />
              </div>
              <div class="quota-field field-sm datepicker-main" :class="{ invalid: $v.invoiceBso.date.$error }">
                <label>{{ $t('Дата') }}:</label>
                <div class="form-date">
                  <v-icon class="date-icon">date_range</v-icon>
                  <VueCtkDateTimePicker
                    v-model="invoiceBso.date"
                    format="DD.MM.YYYY"
                    formatted="LL"
                    :onlyDate="true"
                    :label="''"
                    :autoClose="true"
                    :noButton="true"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field field-md">
                <label>{{ $t('Через кого') }}:</label>
                <v-text-field
                  v-model="invoiceBso.throughWhom"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
              </div>
              <div class="quota-field field-md">
                <label>{{ $t('По доверенности') }}:</label>
                <v-text-field
                  v-model="invoiceBso.byProxy"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="quota-fields">
              <div class="quota-field field-md">
                <label>{{ $t('Основание') }}:</label>
                <v-text-field
                  v-model="invoiceBso.base"
                  outlined
                  dense
                  class="size-small hide-arrows"
                />
              </div>
            </div>
          </div>
          <!--bso item-->
          <div class="form-group">
            <div class="bso-item" v-for="(item, index) in baseBsoInvoices" :key="index">
              <v-btn class="btn-delete" @click.native.stop="deleteBaseBsoInvoice(item.id)" v-if="invoiceBso.statusId !== approvedStatus">
                <v-icon>delete_forever</v-icon>
              </v-btn>
              <div class="form-group">
                <div class="quota-fields align-bottom">
                  <div class="quota-field field-sm">
                    <template v-if="invoiceBso.statusId !== approvedStatus">
                      <div class="select-def" :class="{ invalid: $v.baseBsoInvoice.productionBsoId.$error }">
                        <v-select
                          item-value="id"
                          item-text="name"
                          v-model="item.productionBsoId"
                          :items="productionBsos"
                          outlined
                          dense
                          required
                          clearable
                          @change="updateBaseBsoInvoice(item, 'productionBso')"
                        />
                      </div>
                    </template>
                    <template v-else>
                      <span>{{ item.productionBsoName }}</span>
                    </template>
                  </div>
                  <div class="quota-field field-xs">
                    <label>{{ $t('Начальный') }} №</label>
                    <template v-if="invoiceBso.statusId !== approvedStatus">
                      <div class="select-def" :class="{ invalid: $v.baseBsoInvoice.firstBsoId.$error }">
                        <v-autocomplete
                          item-value="id"
                          item-text="number"
                          v-model="item.firstBsoId"
                          :items="item.bsos"
                          outlined
                          dense
                          required
                          clearable
                          @change="updateBaseBsoInvoice(item, 'firstBso')"
                        >
                          <template v-slot:no-data>
                            <v-list-item>
                              <v-list-item-title>
                                {{ $t('Изготовленных бланков нет') }}
                              </v-list-item-title>
                            </v-list-item>
                          </template>
                        </v-autocomplete>
                      </div>
                    </template>
                    <template v-else>
                      <span>{{ item.firstBsoNumber }}</span>
                    </template>
                  </div>
                  <div class="quota-field field-x" :class="{ invalid: $v.baseBsoInvoice.firstBsoId.count }">
                    <label>{{ $t('Количество') }}</label>
                    <template v-if="invoiceBso.statusId !== approvedStatus">
                      <v-text-field
                        v-model.number="item.count"
                        outlined
                        dense
                        class="size-small hide-arrows"
                        @change="updateBaseBsoInvoice(item, 'count')"
                      />
                    </template>
                    <template v-else>
                      <span>{{ item.count }}</span>
                    </template>
                  </div>
                  <div class="quota-field field-xs">
                    <label>{{ $t('Конечный') }} №:</label>
                    <span>{{ item.lastBsoNumber ? item.lastBsoNumber : '000000' }}</span>
                  </div>
                  <div class="quota-field field-x">
                    <label>{{ $t('Цена') }}</label>
                    <span>{{ item.unitPrice }}</span>
                  </div>
                  <div class="quota-field field-x">
                    <label>{{ $t('Стоимость') }}</label>
                    <span>{{ item.totalPrice }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--addBsoItem-->
          <div class="form-group" v-if="invoiceBso.statusId !== approvedStatus">
            <v-btn
              class="btn-add btn-add-small"
              @click="addBaseBsoInvoice"
            >
              <img src="@/assets/img/plus-icon.png" alt="icon">
              {{ $t('Добавить БСО') }}
            </v-btn>
          </div>
          <div class="form-action">
            <template v-if="invoiceBso.statusId !== approvedStatus">
              <button
                class="btn btn-default blue"
                type="submit"
                @click="statusId = createdStatus"
              >
                {{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default blue"
                type="submit"
                @click="statusId = approvedStatus"
              >
                {{ $t('Сохранить и отправить') }}
              </button>
              <a
                class="btn btn-default blue"
                href="#"
                @click="deleteInvoiceBso"
              >
                {{ $t('Удалить') }}
              </a>
            </template>
            <a
              class="btn btn-default blue"
              @click="printWord"
            >
              {{ $t('Печать') }}
            </a>
            <button
              class="btn btn-default gray"
              @click="onCancel"
            >
              {{ $t('Закрыть') }}
            </button>
          </div>
        </v-form>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import Bso from '@/model/bso'

export default {
  data: () => ({
    breadcrumbs: [],
    invoiceBso: {},
    createdStatus: null,
    approvedStatus: null,
    statusId: null,
    oopts: [],
    baseBsoInvoices: [],
    baseBsoInvoiceValidateState: false,
    productionBsos: [],
    rules: {
      invoiceBso: {
        number: { required },
        date: { required },
        oopt: { required }
      },
      baseBsoInvoice: {
        productionBsoId: {},
        firstBsoId: {},
        count: {}
      }
    }
  }),
  validations () {
    if (!this.baseBsoInvoiceValidate) {
      this.rules.baseBsoInvoice.productionBsoId = { required }
      this.rules.baseBsoInvoice.firstBsoId = { required }
      this.rules.baseBsoInvoice.count = { required }
    } else {
      this.rules.baseBsoInvoice.productionBsoId = {}
      this.rules.baseBsoInvoice.firstBsoId = {}
      this.rules.baseBsoInvoice.count = {}
    }
    return this.rules
  },
  computed: {
    baseBsoInvoiceValidate () {
      return this.baseBsoInvoiceValidateState
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Bso.getInvoiceBsoInfo(this.$route.params.id).then((response) => {
        this.invoiceBso = response.data.invoiceBso
        this.baseBsoInvoices = response.data.baseBsoInvoices
        Bso.getInvoiceBsoFormData().then((response) => {
          this.oopts = response.data.oopts
          this.productionBsos = response.data.productionBsos
          this.createdStatus = response.data.createdStatus
          this.approvedStatus = response.data.approvedStatus
          this.generateBreadcrumbs()
          this.setLoading(false)
        }).catch((error) => {
          console.log(error)
          this.setLoading(false)
        })
      }).catch((error) => {
        this.$router.push({
          name: 'error',
          params: {
            status: error.response.status
          }
        })
        this.setLoading(false)
      })
    },
    updateInvoiceBso () {
      if (this.baseBsoInvoices.length === 0) {
        this.$noty.error(this.$i18n.t('Внимание! В форме не добавлены БСО.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      this.baseBsoInvoices.forEach(element => {
        if (typeof element.productionBsoId === 'number' && typeof element.firstBsoId === 'number' && typeof element.count === 'number' && element.count > 0) {
          this.baseBsoInvoiceValidateState = true
        } else {
          this.baseBsoInvoiceValidateState = false
        }
      })
      if (!this.validateForm()) {
        return
      }

      this.setLoading(true)
      const fd = {
        number: this.invoiceBso.number,
        date: this.invoiceBso.date,
        oopt: this.invoiceBso.oopt,
        throughWhom: this.invoiceBso.throughWhom,
        byProxy: this.invoiceBso.byProxy,
        base: this.invoiceBso.base
      }
      Bso.editInvoiceBso(this.$route.params.id, this.statusId, fd).then((response) => {
        if (response.status === 202) {
          this.onCancel()
        }
        this.setLoading(false)
      }).catch((error) => {
        let msg = error.message
        if (error.response) {
          if (error.response.data.form) {
            msg = this.$i18n.t(error.response.data.form.message)
          } else if (error.response.data.message) {
            msg = this.$i18n.t(error.response.data.message)
          }
        }
        this.$noty.error(msg, {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        this.setLoading(false)
      })
    },
    deleteInvoiceBso () {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Bso.deleteInvoiceBso(this.$route.params.id)
          .then((response) => {
            this.onCancel()
            this.setLoading(false)
          })
          .catch((error) => {
            this.$noty.error(this.$i18n.t('Нельзя удалять утвержденные накладные.'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
            this.setLoading(false)
          })
      }
    },
    addBaseBsoInvoice () {
      Bso.createBaseBsoInvoice(this.invoiceBso.id)
        .then((response) => {
          this.baseBsoInvoices = response.data.baseBsoInvoices
        })
        .catch((error) => {
          console.log(error)
        })
    },
    updateBaseBsoInvoice (data, type) {
      let fd = {}
      if (type === 'productionBso') {
        let productionBso = data.productionBsoId
        if (typeof productionBso === 'undefined') {
          productionBso = null
        }
        fd = {
          productionBso: productionBso,
          firstBso: null,
          count: 0
        }
      }
      if (type === 'firstBso') {
        let firstBso = data.firstBsoId
        if (typeof firstBso === 'undefined') {
          firstBso = null
        }
        fd = {
          productionBso: data.productionBsoId,
          firstBso: firstBso,
          count: data.count
        }
      }
      if (type === 'count') {
        let count = data.count
        if (typeof count === 'string') {
          count = 0
        }
        fd = {
          productionBso: data.productionBsoId,
          firstBso: data.firstBsoId,
          count: count
        }
      }
      this.setLoading(true)
      Bso.editBaseBsoInvoice(data.id, fd)
        .then((response) => {
          this.baseBsoInvoices = response.data.baseBsoInvoices
          this.setLoading(false)
        })
        .catch((error) => {
          this.setLoading(false)
          console.log(error)
        })
    },
    deleteBaseBsoInvoice (id) {
      if (confirm(this.$i18n.t('Вы действительно хотите выполнить данное действие?'))) {
        this.setLoading(true)
        Bso.deleteBaseInvoiceBso(id)
          .then((response) => {
            this.baseBsoInvoices = response.data.baseBsoInvoices
            this.setLoading(false)
          })
          .catch((error) => {
            console.log(error)
            this.setLoading(false)
          })
      }
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Накладные'),
          disabled: false,
          href: '/bso-invoice'
        },
        {
          text: this.$i18n.t('Выдача БСО'),
          disabled: true
        }
      ]
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    // Отмена
    onCancel () {
      this.$router.push({
        name: 'bso-invoice'
      })
    },
    // печать в ворд
    printWord () {
      this.setLoading(true)
      Bso.printInvoiceBso(this.$route.params.id)
        .then(res => {
          if (res.status === 400) {
            this.$noty.warning(this.$i18n.t('Ошибка'), {
              killer: true,
              timeout: 1000,
              layout: 'topRight'
            })
          } else {
            this.forceFileDownload(res)
          }
        })
        .catch(() => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })

      this.setLoading(false)
    },
    // генерация ссылки для скачивания ворд файла
    forceFileDownload (res) {
      const url = window.URL.createObjectURL(new Blob([res.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'invoice_bso.docx')
      document.body.appendChild(link)
      link.click()
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      this.langNpaTab = 0
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-group {
  .bso-item {
    position: relative;
    .btn-delete {
      position: absolute;
      top: 21px;
      right: 0;
    }
  }
  .bso-item + .bso-item {
    margin-top: 20px;
    padding-top: 10px;
    border-top: 1px solid #a1a1a1;
  }
}
</style>
